export default __webpack_public_path__ + "static/media/Thor.d26886bd.png";